export default "__VITE_ASSET__DVNYpiiZ__"